<div class="lds-roller" 
[style.--width1]=" width+ 'px'"
[style.--thickness]=" thickness+ 'px'"
[style.--primaryColor]="primaryColor "
[style.--secondaryColor]="secondaryColor "><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>